import ArticleCard from '@/components/base/ArticleCard';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-3">
            精选推荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            热门文章
          </h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-xl mx-auto">
            精选最新最热的体育资讯与分析，为您带来最专业的体育内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.slice(0, 1).map((article) => (
            <div key={article.id} className="md:col-span-2 lg:col-span-2">
              <ArticleCard article={article} variant="featured" />
            </div>
          ))}
          {featured.slice(1).map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}